import React from "react";

function TraffixAllInOne() {
  var user = JSON.parse(localStorage.getItem("user"));

  var client_type = user && user.traffix_client ? user.traffix_client[0] : null;
  var link =
    process.env.REACT_APP_TRAFFIX_ALL_IN_ONE_LINK +
    "?auth_token=" +
    localStorage.getItem("authToken") + "&client_type=" +
    client_type;  
  return (
    <iframe
      src={link}
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
        position: "absolute",
        top: 0,
        right: 0,
      }}
    />
  );
}

export default TraffixAllInOne;